import { faDownload } from '@fortawesome/pro-light-svg-icons'

import { DashboardModuleListItem } from '@domain-group/suit-theme'

import useCampaignDocument from '@hooks/useCampaignDocument'

import { confirmDelete } from '@functions/entity'

import { CampaignDocumentModel } from '@models/types'

interface DocumentListItemProps {
  campaignDocument: CampaignDocumentModel,
  readOnly?: boolean,
}

const DocumentListItem = (props: DocumentListItemProps) => {
  const { campaignDocument, readOnly } = props

  const {
    campaignDocument: { file, file_file_name, title },
    callbacks: {
      deleteCampaignDocument: deleteFn,
    },
  } = useCampaignDocument(campaignDocument)

  const confirmDeletePayload = {
    callbacks: {
      deleteFn,
    },
    strings: {
      entityName: 'Campaign Document',
    },
  }

  return (
    <DashboardModuleListItem isSidebar title={title} secondaryText={file_file_name}>
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.Actions>
        {/*
         // @ts-expect-error TS2339 */}
        <DashboardModuleListItem.Icon
          href={file}
          icon={faDownload}
          marginRight="medium"
          target="_blank"
        />

        {!readOnly && (
          // @ts-expect-error TS2339
          <DashboardModuleListItem.Icon
            onClick={() => confirmDelete(confirmDeletePayload)}
            type="delete"
          />
        )}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.Actions>
    </DashboardModuleListItem>
  )
}

export default DocumentListItem
